export default 'buildingsPage';
